// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"f5507695","283":"24a25251","558":"0652d030","574":"431f376a","818":"c9ee4826","850":"dd5483e6","938":"9aebe594"}[chunkId] + ".chunk.js";
};